module.exports = __webpack_public_path__ + "img/jy.ca3b825b.png";